export type SettlementTier = 'outpost' | 'town' | 'city';

export type SettlementTierData = {
    radius: number;
    buildingSlots: number;
    caravanSlots: number;
};

export const SETTLEMENT_TIERS: Record<SettlementTier, SettlementTierData> = {
    outpost: { radius: 1, buildingSlots: 24, caravanSlots: 1 },
    town: { radius: 2, buildingSlots: 48, caravanSlots: 2 },
    city: { radius: 3, buildingSlots: 96, caravanSlots: 4 },
};

export function getSettlementTierData(tier: SettlementTier): SettlementTierData {
    return SETTLEMENT_TIERS[tier];
}
